import { render, staticRenderFns } from "./Spjg.vue?vue&type=template&id=2552d107&"
import script from "./Spjg.vue?vue&type=script&lang=js&"
export * from "./Spjg.vue?vue&type=script&lang=js&"
import style0 from "./Spjg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports